module.exports = __webpack_public_path__ + "img/hip-hop.d8021ccb.jpg";